import { Loader2 } from "lucide-react";
import { cn } from "@/utils/module_api";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  fullScreen?: boolean;
  text?: string;
}

const sizeClasses = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-10 w-10",
};

export function LoadingSpinner({
  size = "md",
  className,
  fullScreen = false,
  text,
}: LoadingSpinnerProps) {
  const spinner = (
    <div className={cn("flex flex-col items-center gap-2", className)}>
      <Loader2 className={cn("animate-spin text-primary", sizeClasses[size])} />
      {text && <span className="text-sm text-muted-foreground">{text}</span>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
}

// Convenience component for centering spinner in a container
export function LoadingContainer({
  children,
  loading,
  ...props
}: LoadingSpinnerProps & { loading: boolean; children?: React.ReactNode }) {
  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <LoadingSpinner {...props} />
      </div>
    );
  }
  return <>{children}</>;
}
